import styled from 'styled-components';
import { MIN_TABLET_BREAKPOINT, SELECTORS } from '../../constants/constants';

interface IRedeemRewardStyle {
  isMobileTitle: boolean;
}


export const RedeemBlockContainer = styled.section`
  ${SELECTORS} & {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 100px;
  }
`;

export const ImageSectionContainer = styled.div`
    ${SELECTORS} & {
      margin: 20px 0 20px auto;
      width: 50%;
      
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
   ${SELECTORS} & {
       width: 100%;
       margin: 20px auto 20px auto;
   }
  } 
`;

export const ImageContainer = styled.div`
    ${SELECTORS} & {
      width: fit-content;
      margin: auto;  
    }
    img{
      margin: auto!important;
    }
    
`;

export const RedeemRewardTitle = styled.h2`
  ${SELECTORS} & {
    margin: 0 auto 30px 0;
    font-size: 50px;
    line-height: 50px;
  }
  
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
    ${SELECTORS} & {
        font-size: 32px;
        line-height: 38px;
     }
  } 
`;

export const RedeemRewardTextContainer = styled.div`
  ${SELECTORS} & {
      margin: auto;
      display: block;
      align-content: flex-end;
      width: 50%;
  }
  @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
      ${SELECTORS} & {
         width: 100%;
         text-align: center;
       }
    }

`;

export const RedeemRewardDescription = styled.p`
  display : ${({ isMobileTitle } : IRedeemRewardStyle) => isMobileTitle ? 'none' : 'block'} !important;
  ${SELECTORS} & {
    font-size: 22px;
    font-weight: 400;
    line-height: 24px;
    text-align: left;
  }
   @media (max-width: ${MIN_TABLET_BREAKPOINT}) {
    
    display : ${({ isMobileTitle } : IRedeemRewardStyle) => isMobileTitle ? 'block' : 'none'} !important;
    ${SELECTORS} & {
       width: 100%;
       text-align: left;
     }
  } 
`;

